import { BodyLink, Button } from '@kvdbil/components';
import React, { useState } from 'react';
import Lightbox from '~/App/shared/components/Lightbox';
import YoutubeHero from '~/App/shared/components/YoutubeHero';
import { useIsDevice } from '~/App/shared/hooks/useIsDevice';
import { useTranslation } from '~/Locale';

interface LightboxTutorialProps {
  text: string;
  link?: string | null;
}

export const LightboxTutorial = ({ text, link }: LightboxTutorialProps) => {
  const [isOpen, setOpen] = useState(false);
  const { t } = useTranslation();
  const { isMobile } = useIsDevice();

  if (!link) {
    return null;
  }

  return (
    <>
      <Button
        css={{ padding: 0 }}
        color="info"
        colorShade="dark"
        variant="flat"
        onClick={() => setOpen(open => !open)}
        aria-haspopup="dialog"
      >
        <BodyLink as="span">{text}</BodyLink>
      </Button>

      <Lightbox isOpen={isOpen} onClose={() => setOpen(open => !open)}>
        <YoutubeHero url={link} />
        {!isMobile && (
          <Button onClick={() => setOpen(open => !open)} color="secondary">
            {t('Close')}
          </Button>
        )}
      </Lightbox>
    </>
  );
};
